
export default {
  name: 'Error',
  layout: 'portal',

  props: {
    error: {
      type: Object,
      default: null
    }
  },

  head() {
    const title = this.error.statusCode
    return {
      title
    }
  }
}
